(() => {
  if (customElements.get('eb-geometry-spotlight')) return;

  customElements.define('eb-geometry-spotlight', class extends HTMLElement {
    connectedCallback() {
      this.slider = this.querySelector('[data-geo-height]');
      this.output = this.querySelector('[data-geo-height-output]');
      this.models = [...this.querySelectorAll('[data-geo-model]')].map((el) => ({
        index: el.dataset.modelIndex,
        min: Number(el.dataset.heightMin) || 0,
        max: Number(el.dataset.heightMax) || 0,
      }));
      this.stages = [...this.querySelectorAll('[data-geo-stage]')];
      this.panels = [...this.querySelectorAll('[data-geo-panel]')];
      this.segments = [...this.querySelectorAll('[data-geo-segment]')];

      this.slider?.addEventListener('input', () => {
        const value = Number(this.slider.value);
        if (this.output) this.output.textContent = value;
        const matched = this.match(value);
        if (matched !== null) this.select(matched);
      });

      const start = this.slider ? this.match(Number(this.slider.value)) : '0';
      this.select(start !== null ? start : '0');
    }

    match(height) {
      let nearest = null;
      for (const model of this.models) {
        if (model.min > 0 && model.max > 0 && height >= model.min && height <= model.max) {
          return model.index;
        }
        if (model.min > 0 && model.max > 0) {
          const center = (model.min + model.max) / 2;
          const distance = Math.abs(height - center);
          if (!nearest || distance < nearest.distance) nearest = { distance, index: model.index };
        }
      }
      if (nearest) return nearest.index;
      return this.models.length ? this.models[0].index : null;
    }

    select(index) {
      const selected = String(index);

      [...this.stages, ...this.panels].forEach((el) => {
        const idx = el.dataset.stageIndex ?? el.dataset.panelIndex;
        const active = idx === selected;
        el.classList.toggle('is-active', active);
        el.hidden = !active;
      });

      this.segments.forEach((seg) => {
        seg.classList.toggle('is-active', seg.dataset.segmentIndex === selected);
      });
    }
  });
})();
